/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: SearchCases
// ====================================================

export interface SearchCases_searchCases_client {
  __typename: "Client";
  name: string;
}

export interface SearchCases_searchCases_group {
  __typename: "Group";
  name: string;
}

export interface SearchCases_searchCases {
  __typename: "Case";
  id: string;
  matter: string;
  client: SearchCases_searchCases_client;
  group: SearchCases_searchCases_group | null;
}

export interface SearchCases {
  searchCases: SearchCases_searchCases[];
}

export interface SearchCasesVariables {
  caseName: string;
}
